import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import NavBar from '../blocks/NavBar';
import MenuList from '../blocks/MenuList';
import ContactsBlock from '../blocks/ContactsBlock';

import StoryBlock from './blocks/StoryBlock';
import FlavourBlock from './blocks/FlavourBlock';
import IngredientsBlock from './blocks/IngredientsBlock';
import EventsBlock from './blocks/EventsBlock';

import './home-page.css';

const $ = window.jQuery;
class HomePage extends PureComponent {
  constructor() {
    super();
    this.state = {
      tt: {},
      news: [],
      openSide: false,
    };
  }

  componentDidMount() {
    $('.parallax').parallax();
    this.handleChangeLng(this.props.locale);
  }

  componentDidUpdate(prevProps) {
    if (this.props.locale !== prevProps.locale) {
      this.handleChangeLng(this.props.locale);
    }
  }

  handleChangeLng(locale) {
    $.getJSON(`/locales/${locale}.json`, (tt) => {
      this.setState({ tt });
    }).fail(this.loadDefaultLng);

    $.getJSON(`/events/${locale}.json`, (news) => {
      this.setState({ news });
    }).fail(this.loadDefaultLng);
  }

  loadDefaultLng = () => {
    $.getJSON('/locales/en.json', (tt) => {
      this.setState({ tt });
    });

    $.getJSON('/events/en.json', (news) => {
      this.setState({ news });
    });
  }

  handleOpenSide = () => {
    this.setState({
      openSide: !this.state.openSide
    });
  }

  render() {
    const { locale } = this.props;
    const {
      tt,
      tt: {
        menu,
        lang,
      },
      news,
      openSide,
    } = this.state;
    if (!Object.keys(tt).length || !Object.keys(news).length) return null;
    return (
      <div className="home-page">
        <NavBar
          isHome
          tt={tt}
          locale={locale}
          list={Object.keys(menu)}
          lang={Object.keys(lang)}
          openSide={openSide}
          onOpenSide={this.handleOpenSide}
        />
        <MenuList
          tt={tt}
          list={Object.keys(menu)}
          lang={Object.keys(lang)}
          onClick={this.handleOpenSide}
          className={`slide-down-menu ${openSide && 'show'}`}
        />
        <div className="block kv">
          <div className="robbit" />
          <iframe
            title="youtube"
            className="video"
            src="https://www.youtube.com/embed/HbvAsy7rDUY"
            frameBorder="0"
            gesture="media"
            allow="encrypted-media"
            allowFullScreen
          />
        </div>
        <StoryBlock tt={tt} />
        <FlavourBlock tt={tt} />
        <div className="knot" />
        <IngredientsBlock tt={tt} />
        <EventsBlock
          tt={tt}
          news={news}
          locale={locale}
        />
        {/* <div className="section white">
            <div className="row container">
              <h2 className="header">Parallax</h2>
              <p className="grey-text text-darken-3 lighten-3">Parallax is an effect where the background content or image in this case, is moved at a different speed than the foreground content while scrolling.</p>
            </div>
          </div>
          <div className="parallax-container">
            <div className="parallax">
              <img src="http://unsplash.it/1400/600" alt="what ever" />
            </div>
          </div> */}
        <ContactsBlock tt={tt} />
      </div>
    );
  }
}

HomePage.propTypes = {
  locale: PropTypes.string,
};

HomePage.defaultProps = {
  locale: '',
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/HomePage/index.js